export default __webpack_public_path__ + "static/mercado-pago-restyling-b4a56f431d9cd10f9f48c0cd73d5309c.png";